import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../components/home/card';
import { FileInputTab } from '../tabs/file-input-tab';
import { YoutubeTab } from '../tabs/youtube-tab';

type SourceType = 'file' | 'youtube';

export function HomeRoute() {
    const { t } = useTranslation();

    const [sourceType, setSourceType] = useState<SourceType>('file');

    const tabs = [
        { value: 'file', label: t('route.home.txtInputTypeFile') },
        { value: 'youtube', label: t('route.home.txtInputTypeYoutube') },
    ] as Array<{ value: SourceType, label: string }>;

    function handleSourceTypeChange(nextType: SourceType) {
        if (nextType === sourceType) return;
        setSourceType(nextType);
    }

    return (
        <Card>
            <div className="flex flex-col items-center gap-5 text-center">
                <div className="w-full space-y-4 text-left">
                    <div className="space-y-2">
                        <div role="tablist" aria-label={t('route.home.txtInputTypeLabel')} className="flex w-full items-center gap-2 rounded-full border border-foreground/10 bg-white/70 p-1 text-xs font-semibold text-secondary shadow-[0_12px_30px_-24px_rgba(20,20,60,0.35)] backdrop-blur">
                            {tabs.map((tab) => {
                                const isActive = sourceType === tab.value;
                                const panelId = `source-panel-${tab.value}`;
                                return (
                                    <button
                                        key={tab.value}
                                        type="button"
                                        role="tab"
                                        aria-selected={isActive}
                                        aria-controls={isActive ? panelId : undefined}
                                        tabIndex={isActive ? 0 : -1}
                                        onClick={() => handleSourceTypeChange(tab.value)}
                                        className={`flex-1 rounded-full px-3 py-2 text-xs font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-60 ${isActive
                                            ? 'bg-[#8f7dff] text-white'
                                            : 'bg-white/90 hover:bg-[#8f7dff]/20 cursor-pointer text-foreground shadow-[0_10px_22px_-18px_rgba(40,30,80,0.35)]'
                                            }`}
                                    >
                                        {tab.label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {sourceType === 'file' && <FileInputTab />}
                    {sourceType === 'youtube' && <YoutubeTab />}
                </div>
            </div>
        </Card>
    );
}
